import React from "react";
import { gql } from "@apollo/client";

import SaxophoneMouthpieceField from "components/mouthpiece/SaxophoneMouthpieceField";

export default function SolidouSaxophone() {
  return <SaxophoneMouthpieceField name="solidouSaxophone" />;
}

export function isAvailable({ instrument }) {
  return instrument === "saxophone";
}

export const tabName = "solidouSaxophone";

export function TabLabel() {
  return (
    <span>
      Créer un bec
      <br />
      <small>(Solidou Saxophone)</small>
    </span>
  );
}

export async function handleSubmit(values, client) {
  return client
    .mutate({
      mutation: gql`
        mutation ($saxophoneMouthpiece: SaxophoneMouthpieceInput!) {
          CreateSaxophoneMouthpiece(saxophoneMouthpiece: $saxophoneMouthpiece) {
            saxophoneMouthpiece {
              id
            }
          }
        }
      `,
      variables: {
        saxophoneMouthpiece: values.solidouSaxophone,
      },
    })
    .then(({ data }) => ({
      type: "saxophoneMouthpiece",
      saxophoneMouthpiece:
        data.CreateSaxophoneMouthpiece.saxophoneMouthpiece.id,
    }));
}
